import { Link } from "react-router-dom";

export function Logo({ className = "" }) {
  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`} data-testid="logo-link">
      <img src="/logo-mark.png" alt="Team Assembly logo" className="h-7 w-auto" />
      <span className="font-display text-[17px] font-bold tracking-tight text-ink">
        Team<span className="text-azure">Assembly</span>
      </span>
    </Link>
  );
}
